import { useEffect, useState } from 'react'
import _, { isEmpty } from 'lodash'
import allThemes from './themes.json'
import { useDispatch, useSelector } from 'react-redux'
import * as setting from 'src/app/modules/siteSettings/components/settings'
import { ISettingTypeState } from 'src/app/modules/siteSettings/components/settings'

export const useTheme = () => {
  const dispatch = useDispatch()
  const [theme, setTheme] = useState<any>(allThemes)
  const [themeLoaded, setThemeLoaded] = useState(false)
  const settingTypeData: ISettingTypeState = useSelector((state: any) => state.settingType)

  useEffect(() => {
    if (isEmpty(settingTypeData?.settingType)) {
      dispatch(setting.actions.getSettingType())
    }
  }, [])

  const getSettingType = () => {
    dispatch(setting.actions.getSettingType())
  }
  const settingType: any = settingTypeData?.settingType
    ? settingTypeData?.settingType?.find((item: any) => item.name === 'Backend')
    : {}

  useEffect(() => {
    if (!isEmpty(settingType)) {
      dispatch(setting?.actions.getSpecifiSettingType(settingType?.id, settingType?.name))
    }
  }, [settingType])


  useEffect(() => {
    if (!isEmpty(settingTypeData?.backendData)) {
      // const backendData = mapValues(groupBy(settingTypeData?.setting, 'group.name'), (obj) =>
      //   obj.map((item) => omit(item, 'group.name'))
      // )
      let d: any = {}
      settingTypeData?.backendData &&
        settingTypeData?.backendData['Theme Settings']?.map((item: any) => {
          d[item?.name + ''] = item?.value
        })
      setTheme(d)
      setThemeLoaded(true)
    }
  }, [settingTypeData])

  return { theme, themeLoaded, getSettingType }
}
